import { TimeOffBalancesReport } from "@/pages/employees/time-off/balances/TimeOffBalancesReport.tsx";
import { TimeOffHistoryReport } from "@/pages/employees/time-off/history/TimeOffHistoryReport.tsx";
import { TimeOffRequestEdit } from "@/pages/time-off/edit/TimeOffRequestEdit.tsx";
import { TimeOffCalendar } from "@/pages/time-off/TimeOffCalendar.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { ApiPermission, EmployeeFieldPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export const timeOffRoutes: RouteConfig[] = [
  {
    path: "time-off",
    planFeature: ApiFeatureType.time_off,
    children: [
      {
        path: "calendar",
        allOfEditFieldPermissions: [EmployeeFieldPermission.access_to_leave_timeline],
        children: [
          {
            path: "",
            element: <TimeOffCalendar />,
          },
        ],
      },
      {
        path: "balances-report",
        allOfPermissions: [ApiPermission.reporting_leave_balance],
        children: [
          { path: "", element: <TimeOffBalancesReport /> },
          { path: ":id", element: <TimeOffBalancesReport /> },
        ],
      },
      {
        path: "history-report",
        allOfPermissions: [ApiPermission.reporting_leave_used],
        element: <TimeOffHistoryReport />,
      },
      {
        path: "request",
        children: [
          { path: "new", element: <TimeOffRequestEdit />, isFullScreen: true },
          { path: ":id/edit", element: <TimeOffRequestEdit />, isFullScreen: true },
        ],
      },
    ],
  },
];
